import { keyframes } from '@mui/system';

const SMOOTH_EASING = 'cubic-bezier(0.25, 0.1, 0.25, 1)';

const slideOutRightThenInFromLeft = keyframes`
  0% { right: 40px; left: auto; transform: translate(0, -50%); }
  48% { right: -600px; left: auto; transform: translate(0, -50%); }
  52% { right: auto; left: -600px; transform: translate(0, -50%); }
  100% { right: auto; left: 40px; transform: translate(0, -50%); }
`;

const slideOutLeftThenInFromRight = keyframes`
  0% { right: auto; left: 40px; transform: translate(0, -50%); }
  48% { right: auto; left: -600px; transform: translate(0, -50%); }
  52% { right: -600px; left: auto; transform: translate(0, -50%); }
  100% { right: 40px; left: auto; transform: translate(0, -50%); }
`;

const ANIMATION_DURATION_MS = 550;

export const useStyles = (isProfileOpen: boolean, shouldAnimate: boolean) => {
  return {
    modal: {
      position: 'fixed',
      top: '50%',
      bottom: 'auto',
      transform: 'translate(0, -50%)',
      background: 'transparent',
      outline: 'none',
      zIndex: 1090,
      ...(shouldAnimate
        ? {
            willChange: 'left, right, transform',
            ...(isProfileOpen
              ? {
                  animation: `${slideOutRightThenInFromLeft} ${ANIMATION_DURATION_MS}ms ${SMOOTH_EASING} forwards`,
                }
              : {
                  animation: `${slideOutLeftThenInFromRight} ${ANIMATION_DURATION_MS}ms ${SMOOTH_EASING} forwards`,
                }),
          }
        : isProfileOpen
          ? {
              right: 'auto',
              left: '40px',
            }
          : {
              right: '40px',
              left: 'auto',
            }),
    },
    box: (flexDirectionRow = false) => ({
      display: 'flex',
      flexDirection: flexDirectionRow ? 'row' : 'column',
      justifyContent: 'center',
      alignItems: flexDirectionRow ? 'start' : 'center',
      gap: 2,
      outline: 'none',
    }),
  };
};
